export const FirebaseConfig = {
	"projectId": "zigrides1",
	"appId": "1:283663599317:web:b7b50a19c07e94962e045c",
	"databaseURL": "https://zigrides1-default-rtdb.asia-southeast1.firebasedatabase.app",
	"storageBucket": "zigrides1.appspot.com",
	"locationId": "asia-south1",
	"apiKey": "AIzaSyAjqOPZvsCKf7o_tIHmIdTdDFOYgwrdvVE",
	"authDomain": "zigrides1.firebaseapp.com",
	"messagingSenderId": "283663599317",
	"measurementId": "G-62RFMF51TY"
};